exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-6b091ec2]{margin-top:50px}.item .header[data-v-6b091ec2]{height:40px;line-height:40px;border-bottom:1px solid #ccc}.item .item-remind[data-v-6b091ec2]{margin-top:10px}.item .item-remind .remind-input[data-v-6b091ec2]{width:200px}.item .item-remind .radio-group[data-v-6b091ec2]{margin-left:50px}\n", ""]);

// exports
